<!--
/**
 * Component: UploadPicture
 * Describe: 上传图片（单图）
 * Warning!!: 注意：每次新增加tokenType，要往vueX里添加ImageBase和Token
 * Attribute:
 *  - rules <Objcet> 图片尺寸、比例等限制
 *    {
 *      ratio: 比例
 *      width: 宽度必需等于
 *      height: 高度必需等于
 *      minWidth: 最小宽
 *      minHeight: 最小高
 *      maxWidth: 最大宽
 *      maxHeight: 最大高
 *      minSize: 最小size
 *      maxSize: 最大size
 *    }
 *  - tokenType  <String> 获取token的type
 *  - scale <Number> 在页面显示的panel 与原图的缩放比例（乘）
 *  - rulesTipShow <Boolean> 是否展示条件 默认展示 true
 *  - tipsDesc <String> 有需要其它展示在框里的信息 默认无
 *  - crypto <Boolean> 是否需要对图片进行加密 默认false
 *  - control <Boolean> 是否需要展示图片操作栏（替换 ｜ 删除） 默认false
 *  - initBox <Array> 空盒子状态时的宽高（默认[240, 150]）,依然遵循 scale 规则

 * Event:
 *  - upload-success 上传成功的回调（会携带 { src, uploadSrc, width, height } 参数）
-->

<template>
    <el-upload
        :http-request="picUpload"
        ref="elUpload"
        action
        drag
        :show-file-list="false"
        :class="{ disabled, error }"
        :style="picStyle"
        :disabled="disabled"
        v-loading="!percent && loading">
        <template v-if="picSrc">
            <img :src="picSrc" class="upload" :class="{fill: isFill}">
            <div class="control-bottom" v-if="control">
                <div class="control-bottom-box">
                    <el-button class="change-btn"></el-button>
                    <i slot="reference" class="control-bottom-btn el-icon-sort" title="替换图片" style="cursor: pointer;" />
                    <span>替换</span>
                </div>
                <div class="control-bottom-box" @click.prevent.stop="clear">
                    <i class="control-bottom-btn el-icon-circle-close" title="删除图片" style="cursor: pointer;" />
                    <span>删除</span>
                </div>
            </div>
        </template>
        <template v-else>
            <i class="el-icon-circle-plus"></i>
            <p v-if="rulesTip && rulesTipShow" v-html="rulesTip"></p>
            <p v-if="tipsDesc" v-html="tipsDesc"></p>
        </template>
        <div class="percent" v-show="loadFail || percent">
            <template v-if="loadFail">图片加载失败</template>
            <template v-else>
                进度：{{ percent }}%<br/>
                速度：{{ speed }}
            </template>
        </div>
    </el-upload>
</template>

<script>
import imgCrypto from '@kk/img-crypto';

export default {
    name: 'UploadPicture',
    data() {
        return {
            loading: false,
            picSrc: '',
            percent: 0,
            speed: 0,
            loadFail: false,
            oneMbBytes: 1024 * 1024,
        }
    },
    props: {
        rules: {
            type: Object,
            default() {
                return {}
            }
        },
        tokenType: {
            type: String,
            default() {
                return 'cover'
            }
        },
        src: {
            type: String
        },
        scale: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        },
        tipsDesc: {
            type: String
        },
        isFill: {
            type: Boolean,
            default: false
        },
        rulesTipShow: {
            type: Boolean,
            default: true
        },
        crypto: {
            type: Boolean,
            default: false
        },
        control: {
            type: Boolean,
            default: false
        },
        initBox: {
            type: Array,
            default() {
                return [240, 150]
            }
        },
        suffix: {
            type: Array,
            default() {
                return ['jpg', 'png', 'webp']
            }
        },
    },
    computed: {
        picStyle() {
            const init = this.initBox
            let width = init[0]
            let height = init[1]
            if (this.rules) {
                const ruleW = this.rules.width || this.rules.minWidth
                const ruleH = this.rules.height || this.rules.minHeight
                if (ruleW) {
                    width = ruleW > width ? width : ruleW
                }
                if (ruleH) {
                    height = ruleH * width / ruleW
                }
                width = width * this.scale
                height = height * this.scale
            }
            return {
                width: width + 'px',
                height: height + 'px',
                minWidth: width + 'px'
            }
        },
        rulesTip() {
            let str = ''
            let tip = [null, null]
            tip[0] = this.rules.width || this.rules.minWidth
            tip[1] = this.rules.height || this.rules.minHeight
            if (tip[0] || tip[1]) {
                str += `${ tip[0] } * ${ tip[1] }`
            }
            if (this.rules.suffix) {
                str += '<br/>'
                str += `格式为 ${ this.rules.suffix }`
            }
            if (this.rules.minSize || this.rules.maxSize) {
                str += '<br/>'
                if (this.rules.minSize && this.rules.maxSize) {
                    str += `${ this.rules.minSize } < size < ${ this.rules.maxSize }`
                } else {
                    str += 'size '
                    if (this.rules.minSize) {
                        str += `> ${ this.rules.minSize}`
                    } else {
                        str += `< ${ this.rules.maxSize}`
                    }
                }
                str += 'Mb'
            }
            return str
        },
    },
    watch: {
        src(newVal) {
            this.picSrc = newVal
            const loadImg = (url) => {
                this.loadFail = false
                this.loading = true
                let image = new Image()
                image.src = url
                image.onload = () => {
                    this.loading = false
                }
                image.onerror = () => {
                    this.loadFail = true
                    this.loading = false
                }
            }
            if (newVal) {
                /** 预览图片解密 */
                if (this.crypto) {
                    this.loadFail = false
                    this.loading = true
                    imgCrypto.decrypt(newVal).then(blob => {
                        this.picSrc = URL.createObjectURL(blob);
                    }).catch(() => {
                        this.loadFail = true
                    }).finally(() => {
                        this.loading = false
                    });
                    return;
                }
                loadImg(newVal);
            }
        }
    },
    created() {
        if (this.src) {
            this.picSrc = this.src
            /** 预览图片解密 */
            if (this.crypto) {
                imgCrypto.decrypt(this.src).then(blob => {
                    this.picSrc = URL.createObjectURL(blob);
                });
            }
        }
    },
    methods: {
        // 图片上传
        picUpload(params) {
            this.loading = true
            this.loadFail = false
            const file = params.file
            const localSrc = window.URL.createObjectURL(file)
            this.picSrc = localSrc

            const suffix = this.$util.getFileName(file.name, 'suffix');
            let suffixAry = this.suffix.map(item => {
                return item.toUpperCase()
            }).concat(this.suffix);
            if (suffixAry.includes('jpg')) {
                suffixAry = [...suffixAry, 'jpeg', 'JPEG'];
            }
            const isPic = suffixAry.includes(suffix);
            if (isPic) {
                let image = new Image()
                image.src = localSrc
                image.onload = () => {
                    const rules = this.rules
                    const width = image.width
                    const height = image.height
                    let error = []
                    if (rules.width && width !== rules.width) {
                        error.push('宽度')
                    }
                    if (rules.height && height !== rules.height) {
                        error.push('高度')
                    }
                    if (rules.minWidth && width < rules.minWidth) {
                        error.push('最小宽')
                    }
                    if (rules.minHeight && height < rules.minHeight) {
                        error.push('最小高')
                    }
                    if (rules.maxWidth && width > rules.maxWidth) {
                        error.push('最大宽')
                    }
                    if (rules.maxHeight && height > rules.maxHeight) {
                        error.push('最大高')
                    }
                    if (rules.ratio && width / height !== rules.ratio) {
                        error.push('宽高比')
                    }
                    if ((rules.minSize && file.size < rules.minSize * this.oneMbBytes) || (rules.maxSize && file.size > rules.maxSize * this.oneMbBytes)) {
                        error.push('大小')
                    }
                    if (error.length) {
                        this.$message.error(error.join('、') + '不符合要求')
                        this.picSrc = ''
                        this.loading = false
                    } else {
                        this.$root.bus.$emit('uploadQiniuFile', {
                            file: file,
                            type: this.tokenType,
                            crypto: this.crypto,
                            progress: ({ percent, speed }) => {
                                this.percent = percent
                                this.speed = speed
                            },
                            callback: res => {
                                const src = localStorage.getItem(this.tokenType + 'ImageBase') + res.key
                                this.$emit('upload-success', {
                                    file,
                                    src,
                                    uploadSrc: res.key,
                                    width,
                                    height
                                })
                                this.percent = 0
                                window.URL.revokeObjectURL(file)
                                this.loading = false
                            },
                            error: () => {
                                this.loading = false
                                this.picSrc = ''
                                this.$message.error('上传失败，请重新上传')
                                this.$emit('upload-success', {
                                    src: '',
                                    uploadSrc: ''
                                })
                            }
                        })
                    }
                }
            } else {
                this.$message.error('请上传图片格式的文件')
                this.picSrc = ''
                this.loading = false
                this.$emit('upload-error')
            }
        },
        // 替换图片
        openChoose() {
            if (this.loading) {
                return;
            }
            // this.$refs.inputEle.value = '';
            // this.$refs.changeBtn.click();
        },
        // 删除图片
        clear() {
            this.$refs.elUpload.clearFiles();
            this.picSrc = '';
            this.$emit('clear', {});
        },
    }
}
</script>

<style lang="scss">
.disabled {
    .el-upload-dragger {
        cursor: not-allowed;
        i {
            color: $gray;
        }
        &:hover {
            border-color: #DCDFE6;
            i, p {
                color: $gray;
            }
        }
    }
}
.error .el-upload-dragger {
    border-color: $red!important;
    i, p {
        color: $red!important;
    }
}
.el-upload-dragger {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: #F5F7FA;
    border: 1px dashed #DCDFE6;
    border-radius: 4px;
    cursor: pointer;
    i {
        color: $yellow;
        font-size: 36px;
    }
    p {
        color: #999;
        line-height: 24px;
        padding: 8px;
    }
    img {
        width: 100%;
        height: 100%;
    }
    &:hover {
        border-color: #d9d9d9;
        p {
            color: #666;
        }
        i {
            color: $yellowhover;
        }
        .control-bottom {
            transform: translate(0, 0);
        }
    }
    .percent {
        @include absoluteColumn;
        z-index: 2;
        line-height: 30px;
        background: rgba(0, 0, 0, 0.7);
        color: $yellow;
    }
}
.el-upload:focus {
    .el-upload-dragger {
        border-color: #DCDFE6;
    }
}
.fill {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
.control-bottom {
    line-height: 2;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    color: white;
    background-color: rgba(73, 87, 139, .64);
    font-size: 1.2em;
    display: flex;
    justify-content: space-around;
    align-items: center;
    transform: translate(0, -100%);
    transition: all .2s ease .1s;
    padding: 5px 0;

    .control-bottom-box {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .change-btn {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
        }
    }

    .control-bottom-btn {
        font-size: 20px;
        transform: all .2s;

        &.disabled {
            color: #ababab;
            cursor: not-allowed;
        }

        &:not(.disabled):hover {
            transform: rotate(90deg) scale(1.2);
        }
    }

    span {
        font-size: 14px;
        color: #FFE120;
        margin: 0 5px;
    }

    .el-icon-sort {
        transform: rotate(90deg);
    }
}
</style>
